import { reducer } from './workspaces';

export default reducer;
